<div
	 class="container"
	 fxFill
	 fxLayout="column"
	 [class.is-group]="isGroup">
	<ion-header (mousedown)="back(); hideKeyboard()">
		<ion-toolbar>
			<div slot="start" fxLayoutAlign="start center">
				<ion-icon fxFlex="none" name="chevron-back-outline"></ion-icon>
				<app-avatar fxFlex="none"
							[data]="chat?.chatter"
							[type]="chat?.chatter_type"
							[favorite]="!!chat?.chatter?.favorite_company_id">
				</app-avatar>
			</div>
			<ion-title>{{ chat?.chatter?.name }}</ion-title>
		</ion-toolbar>
	</ion-header>
	<ion-progress-bar *ngIf="requesting" type="indeterminate"></ion-progress-bar>
	<app-list-status [requesting]="requesting" [data]="messages"></app-list-status>
	<div
		 id="messagesContainer"
		 (mousedown)="hideKeyboard()"
		 fxLayout="column"
		 fxLayoutGap="10px"
		 fxFlex>
		<ng-container *ngFor="let message of messages">
			<ng-container *ngIf="message.author_id === user.id; else notMe">
				<div fxFlex="none" class="message-container this-is-me">
					<div class="message-box" fxLayout="column">
						<div
							 class="message"
							 fxFlex="none"
							 [innerHtml]="message.message | sanitize">
						</div>
						<div fxFlex="none"
							 fxLayout="row"
							 fxLayoutAlign="end center">
							<small class="muted" fxFlex="none">
								{{ message.created_at | chatDatetime }}
							</small>
							<ng-container *ngIf="message.read_by; else notReadYet">
								<ion-icon name="checkmark-done-outline"></ion-icon>
							</ng-container>
							<ng-template #notReadYet>
								<ion-icon name="checkmark-outline"></ion-icon>
							</ng-template>
						</div>
					</div>
				</div>
			</ng-container>
			<ng-template #notMe>
				<div fxFlex="none" class="message-container not-me">
					<div class="message-box" fxLayout="column">
						<div *ngIf="isGroup"
							 fxLayout="row"
							 fxLayoutAlign="start center"
							 fxLayoutGap="5px">
							<app-avatar
										fxFlex="none"
										size="small"
										[data]="message.author">
							</app-avatar>
							<small fxFlex class="truncate">
								{{ message.author?.name | truncate:2 }}
							</small>
						</div>
						<div
							 class="message"
							 fxFlex="none"
							 [innerHtml]="message.message | sanitize">
						</div>
						<ng-container *ngIf="message.key">
							<div
								 fxLayoutAlign="start center"
								 fxLayoutGap="10px">
								<ion-button size="small"
											[fill]="message?.answer === false ? 'solid':'outline'"
											color="danger"
											[disabled]="yesNoDisabled(message)"
											(click)="answer(message, false)">
									NO
								</ion-button>
								<ion-button size="small"
											[fill]="message?.answer === true ? 'solid':'outline'"
											color="primary"
											[disabled]="yesNoDisabled(message)"
											(click)="answer(message, true)">
									YES
								</ion-button>
							</div>
						</ng-container>
						<div
							 class="muted"
							 fxFlex="none"
							 fxLayoutAlign="end center">
							<small fxFlex="none">
								{{ message.created_at | chatDatetime }}
							</small>
						</div>
					</div>
				</div>
			</ng-template>
		</ng-container>
	</div>
	<ion-progress-bar *ngIf="requesting" type="indeterminate"></ion-progress-bar>
	<div
		 fxFlex="none"
		 fxLayout="column"
		 class="footer">
		<div
			 [class.disabled]="requesting"
			 fxFlex="none"
			 fxLayout="row"
			 fxLayoutGap="5px">
			<input
				   #messageInput
				   fxFlex
				   [(ngModel)]="message"
				   [placeholder]="'Type something...' | translate"
				   (input)="error = null"
				   (focus)="inputFocusIn()"
				   (blur)="blockInputFocus || messageInput.focus()"
				   (keyup.enter)="submit()" />
			<button
					type="button"
					fxFlex="none"
					(click)="submit($event)">
				<ion-icon size="" name="send-sharp"></ion-icon>
			</button>
		</div>
		<small
			   fxFlex="none"
			   class="error color-danger ion-text-left"
			   *ngIf="error"
			   [innerHtml]="error">
		</small>
	</div>
</div>